import type { ReactNode } from 'react';
import { TenantBrandingProvider } from '@/contexts/AcademyBrandingContext';
import { playEventDisplayTheme } from './playEventDisplayTheme';

interface PlayEventDisplayShellProps {
  primaryColor?: string | null;
  secondaryColor?: string | null;
  children: ReactNode;
}

export function PlayEventDisplayShell({
  primaryColor,
  secondaryColor,
  children,
}: PlayEventDisplayShellProps) {
  return (
    <TenantBrandingProvider
      primaryColor={primaryColor ?? undefined}
      secondaryColor={secondaryColor ?? undefined}
    >
      <div className={playEventDisplayTheme.shell}>{children}</div>
    </TenantBrandingProvider>
  );
}
